export const locale = {
  lang: 'en',
  data: {
  /*  MENU: {
      USER:'Kullanıcılar',
      ROLE:'Rol Yönetimi',
      DENEME:"Deneme",
      ROLEMANAGMENT:"Roller",
      COMPANY:"Şirketler",
      PRODUCTSERVİCE:"Ürün/Hizmet",
      INVOICE: {
        COLLAPSIBLE: 'Yönetim',
        LIST: {
          LIST:"Tanımlamalar",
          DESCRIPITON:"Açıklama",
          CATEGORY:"Kategori",
          CURRENCY : "Para Birimi"
        },
        PREVIEW: 'Ayarlar'
      },
      OFFER:"Teklif"
    }*/
  }
}
